import React from 'react';
import ItemsView from '../components/ItemsView';

const VinylsView = () => <ItemsView type="Vinyl" />;

export default VinylsView;
